import CustomCategoryType from "../../../entities/CustomCategoryType";

class CustomCategory {
    public id: string ;
    public code: string;
    public name: string;
    public description: string;
    public createdAt: number;
    public categoryType: CustomCategoryType;

    constructor(
        id: string,
        code: string,
        name: string,
        description: string,
        createdAt: number,
        categoryType: CustomCategoryType
    ) {
        this.id = id;
        this.code = code;
        this.name = name;
        this.description = description;
        this.createdAt = createdAt;
        this.categoryType = categoryType;
    }
}

export default CustomCategory;